<!--婴幼儿管理-->
<template>
  <div class="root-container">
    <el-form ref="registerRef" label-width="90px" :model="param" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="patriarchPhone">
            <el-input :readonly="true" style="width: 270px" placeholder="" v-model="param.patriarchPhone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="会员姓名:" prop="name">
            <el-input style="width: 270px" v-model="param.name" placeholder="" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="家长姓名:" prop="patriarchName">
            <el-input style="width: 270px" placeholder="" :readonly="true" v-model="param.patriarchName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:" prop="gender">
            <el-select v-model="param.gender" placeholder="请选择" style="width: 270px" disabled>
              <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="版本:" prop="lessonId">
            <el-select v-model="param.lessonId" placeholder="请选择" style="width: 270px" @change="changeLessonIdX"
              clearable="">
              <el-option v-for="item in [
                { label: 'A', value: 2 },
                { label: 'B', value: 1 },
              ]" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业务:" prop="yuw_id">
            <el-select placeholder="请选择" style="width: 270px" clearable="" v-model="param.yuw_id" @change="changeyuwID">
              <el-option v-for="item in yuwList" :key="item.storeLessonId" :label="item.name" :value="item.storeLessonId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="选择卡:" prop="expCardId">
            <el-select style="width: 270px" v-model="param.expCardId" placeholder="请选择" clearable=""
              @change="changeCardIDs">
              <el-option v-for="item in cardList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="param.validityTime" label="有效期:" prop="validityTime">
            <el-input style="width: 250px; margin-right: 4px" v-model="param.validityTime" placeholder=""
              readonly=""></el-input>
          </el-form-item>
          <el-form-item v-else label="有效期:" prop="cardTime">
            <el-input-number style="width: 250px; margin-right: 4px" v-model="param.cardTime" placeholder=""
              disabled></el-input-number>天
          </el-form-item>

        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="价格:" prop="totalPay">
            <el-input-number style="width: 270px" v-model="param.totalPay" placeholder="" disabled></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="!param.validityTime">
          <el-form-item label="总课时(正价/赠送):" prop="classCountUpdate">
            <el-input style="width: 270px" placeholder="" v-model="param.classCountUpdate" :readonly="true"></el-input>
          </el-form-item>
        </el-col>
        <el-form-item v-else label="频率:" prop="frequency">
          <el-input style="width: 250px; margin-right: 4px" v-model="param.frequency" placeholder="" readonly="">
            <span slot="suffix">课/周</span>
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="12" v-if="!param.validityTime">
          <el-form-item label="赠送课时:" prop="extGiveClassCount">
            <el-input style="width: 270px" placeholder="" v-model="param.extGiveClassCount"
              @input="handleGiveClassInput"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="优惠金额:" prop="givenPay">
            <el-input-number style="width: 270px" v-model="param.givenPay" placeholder="" @change="changeGAITFLS"
              :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="礼品:" prop="gift">
            <el-input style="width: 270px" placeholder="" v-model="param.gift"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="实付金额:" prop="realPay">
            <el-input-number style="width: 270px" v-model="param.realPay" placeholder="" disabled
              :min="0"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="邀约人:" prop="inviteWorker">
            <el-select style="width: 270px" v-model="param.inviteWorker" placeholder="下拉选择(员工)">
              <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="渠道:" prop="source">
            <el-select clearable placeholder="请选择" style="width: 270px" v-model="param.source">
              <el-option v-for="item in sourceOptions" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12" v-if="param.source === '网络咨询(NI)'">
          <el-form-item label="二级渠道:">
            <el-select v-model="param.sourceTwo" clearable placeholder="请选择">
              <el-option v-for="item in sourceTwoOptions" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="param.source === '异业合作'">
          <el-form-item label="合作方:">
            <el-select v-model="param.sourceTwo" clearable placeholder="请选择">
              <el-option v-for="item in frontBizTypeList" :key="item.name" :label="item.name" :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="param.source === 'Peferral转介绍'">
          <el-form-item label="介绍人手机号:">
            <el-input style="width: 270px" v-model="param.introducer" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-for="(item, index) in param.marketOrderRecordDTOList" :key="index">
        <el-col :span="12">
          <el-form-item label="销售:">
            <el-select clearable placeholder="下拉选择" style="width: 270px" v-model="item.workerId">
              <el-option v-for="item in allWorker" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="业绩分配:">
            <el-input-number v-model="item.markRatio" :min="0" placeholder="请输入业绩分配" :precision="1"></el-input-number>
            <span>%</span>
            <i class="el-icon-circle-plus" style="font-size: 20px; cursor: pointer"
              v-if="index == param.marketOrderRecordDTOList.length - 1" @click="clickAddItemDTO"></i>
            <i class="el-icon-remove" style="font-size: 20px; cursor: pointer" v-else @click="clickDelItemDTO(index)"></i>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="备注:" prop="remark">
        <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" style="width: 665px"
          v-model="param.remark"></el-input>
      </el-form-item>
      <el-form-item label="语音备注:" prop="recording">
        <div style="width: 665px;display: flex;align-items: center;">
          <soundRecording ref="soundRecord" @clickRecStop="clickRecStop" @clickRecClear="clickRecClear" />
          <div v-if="audio" style="margin-left: 20px;">
            <audio controls ref="audio" class="aud" controlsList="nodownload noplaybackrate">
              <source :src="audio" />
            </audio>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleUpdate()">保存</el-button>
    </div>
    <worker-word :key="refreshWord" :word-type="wordType" :t-data="tData" :show="showWordDlg"
      @onWorkerWord="handleWord"></worker-word>
  </div>
</template>

<style></style>

<script>
import globaldata from "@/utils/globaldata";
import commonUtils from "../../../utils/commonUtils";
import { selectChild, updateChildInfo } from "../../../api/userChild";
import messageUtils from "../../../utils/messageUtils";
import soundRecording from "@/components/soundRecording";
import { qlLessonTemplate } from "@/api/StoreLesson";
import { queryListStoreLessonCardByLessonIdGET } from "@/api/storeFront";
import { frontBizTypeList } from "@/api/frontBizType";
import { createUserByCard } from "@/api/userByCard";
import WorkerWord from "@/components/WorkerWord/WorkerWord";

export default {
  name: "UpdateChildInfo",
  props: {
    childId: Number,
    storeLessonExpCards: Array,
  },
  components: {
    soundRecording,
    WorkerWord,
  },
  data() {
    return {
      tData: null,
      wordType: 0,
      showWordDlg: false,
      refreshWord: "",
      rules: {
        expCardId: [
          {
            required: true,
            message: "请选择卡",
            trigger: "change",
          },
        ],
        // inviteWorker:[
        //   {
        //     required: true,
        //     message: "请选择邀约人",
        //     trigger: ["change", "blur"],
        //   },
        // ],
        // cardTime: [
        //   {
        //     required: true,
        //     message: "请填写有效期",
        //     trigger: ["change", "blur"],
        //   },
        // ],
        // classCount: [
        //   {
        //     required: true,
        //     message: "请填写总课时",
        //     trigger: "blur",
        //   },
        // ],
        extGiveClassCount: [
          {
            required: true,
            message: "请填写赠送课时",
            trigger: "blur",
          },
        ],
      },
      allWorker: [],
      genderOptions: [
        {
          value: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],
      sourceTwoOptions: [
        { name: "美团" },
        { name: "大众点评" },
        { name: "官网" },
        { name: "其他" },
      ],
      frontBizTypeList: [],

      param: {},

      sourceOptions: [
        { name: "自然到访(WI)" },
        { name: "电话咨询(CI)" },
        { name: "网络咨询(NI)" },
        { name: "Peferral转介绍" },
        { name: "PT带到访" },
        { name: "CO" },
        { name: "异业合作" },
      ],

      yuwList: [],
      cardList: [],
      audio: ''
    };
  },
  mounted() { },
  created() {
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
    let param = {
      storeFrontId: globaldata.getAdminStore().storeFrontId,
    };
    frontBizTypeList(param).then((response) => {
      this.frontBizTypeList = response.data;
    });
    // this.initParam();
  },
  methods: {
    handleGiveClassInput(e) {
      let self = this
      console.log(e, 'eeeeeeeeeeeeeeee', self.param)

      if (self.param.expCardId) {
        let total = self.param.classCount + self.param.giveClassCount + Number(e) + '(' + self.param.classCount + '/' + (self.param.giveClassCount + Number(e)) + ')'
        self.$set(self.param, "classCountUpdate", total);
        // self.param.extGiveClassCount
      }
    },
    clickRecStop(audio) {
      if (audio == 1) {
        this.$refs.soundRecord.recStop()
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      } else {
        let timer = setInterval(() => {
          this.audio = this.$refs.soundRecord.audio
          this.$refs.audio.src = this.audio
          this.$refs.soundRecord.dialogVisible = false
          // console.log(this.$refs.soundRecord.audio, 'refs.soundRecord.audio')
          clearInterval(timer)
        }, 500)
      }
    },
    clickRecClear() {
      this.audio = ''
    },
    clickDelItemDTO(index) {
      this.$delete(this.param.marketOrderRecordDTOList, index);
    },
    clickAddItemDTO() {
      let is_add = true;
      try {
        this.param.marketOrderRecordDTOList.forEach((item) => {
          // || item.markRatio == NaN
          // if (!item.workerId ) {
          //   is_add = false;
          //   this.$message.warning("请先填写销售");
          //   // /业绩分配
          //   throw new Error("Something bad happened");
          // }
        });
      } catch (error) {
        if (error == "Something bad happened") {
          throw error;
        }
      }
      if (is_add) {
        this.param.marketOrderRecordDTOList.push({
          workerId: "",
          markRatio: "",
        });
      }
    },
    getStoreWorkersInfo(workers) {
      this.allWorker = workers;
    },
    changeCardIDs(e) {
      let self = this;
      self.$set(this.param, "extGiveClassCount", 0);

      self.cardList.forEach((item) => {
        if (item.id == e) {
          let total = item.totalClassCount + item.giveClassCount + '(' + item.totalClassCount + '/' + item.giveClassCount + ')'
          self.$set(self.param, "totalPay", item.valueMoney);
          self.$set(self.param, "classCount", item.totalClassCount);
          self.$set(self.param, "giveClassCount", item.giveClassCount);
          self.$set(self.param, "realPay", item.valueMoney);
          self.$set(self.param, "realPay_oldp", item.valueMoney);
          if (item.consumeType == 1) {
            self.$set(self.param, "validityTime", item.startTime + ' ~ ' + item.endTime);
            self.$set(self.param, "frequency", item.frequency);
          } else {
            self.$set(self.param, "validityTime", '');
            self.$set(self.param, "frequency", '');
            self.$set(self.param, "classCountUpdate", total);
            self.$set(self.param, "cardTime", item.validDays);
          }
        }
      });
    },
    changeyuwID(e) {
      this.$set(this.param, "expCardId", null);
      this.$set(this.param, "cardTime", "");
      this.$set(this.param, "totalPay", "");
      this.$set(this.param, "classCount", "");
      this.$set(this.param, "realPay", "");
      this.$set(this.param, "validityTime", "");
      this.$set(this.param, "frequency", "");
      this.cardList = [];
      if (e) {
        this.selectCardsHttp(e);
      }
    },
    async selectCardsHttp(storeLessonId) {
      const response = await queryListStoreLessonCardByLessonIdGET({
        storeLessonId,
      });
      if (response.code === 20000) {
        this.cardList = response.data;
      }
    },
    changeLessonIdX(e) {
      this.$set(this.param, "yuw_id", null);
      this.$set(this.param, "expCardId", null);
      this.$set(this.param, "cardTime", "");
      this.$set(this.param, "totalPay", "");
      this.$set(this.param, "classCount", "");
      this.$set(this.param, "realPay", "");
      this.$set(this.param, "validityTime", "");
      this.$set(this.param, "frequency", "");
      this.yuwList = [];
      this.cardList = [];
      if (e) {
        this.qlLessonTemplateHttp(e);
      }
    },
    async qlLessonTemplateHttp(lessonId) {
      const response = await qlLessonTemplate({
        lessonId,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
      });
      if (response.code === 20000) {
        this.yuwList = response.data;
      }
    },
    // 初始化参数
    initParam() {
      let param = {
        id: this.childId,
      };

      selectChild(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        console.log(this.$refs, 'this.$refs.soundRecord========')

        // this.param = {
        //   name: data.name,
        //   petName: data.petName,
        //   birthday: data.birthday,
        //   gender: data.gender,
        // };
        this.param = data;
        this.$set(this.param, "extGiveClassCount", 0);
        this.$set(this.param, "givenPay", 0);
        this.$set(this.param, "gift", '无');
        this.$set(this.param, "marketOrderRecordDTOList", [
          { workerId: "", markRatio: "" },
        ]);
        this.$nextTick(() => {
          this.audio = data.recording
          this.$refs.soundRecord.audio = data.recording
          this.$refs.soundRecord.localUrl = data.recording
        })
      });
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleUpdate() {
      let self = this;
      self.$refs["registerRef"].validate((valid) => {
        if (valid) {
          if (
            self.param.marketOrderRecordDTOList &&
            self.param.marketOrderRecordDTOList.length
          ) {
            let sum = 0;
            let is_add = true;
            self.param.marketOrderRecordDTOList.forEach((item) => {
              if (item.workerId != '') {
                sum += item.markRatio;
              }
              // || item.markRatio == NaN
              if (!item.workerId) {
                is_add = false;
              }
            });
            if (sum == 100 || sum == 0) {

            } else {
              self.$message.error("业绩分配错误");
              return;
            }
            // if (!is_add) {
            //   self.$message.error("请先填写销售");
            //   // /业绩分配
            //   return;
            // }
            self.tData = {
              storeFrontId: globaldata.getAdminStore().storeFrontId,
              adminWord: "",
              ...this.param,
              audio: this.audio,
              storeLessonCardId: this.param.expCardId,
            };
            self.wordType = 1;
            self.refreshWord = new Date().getTime();
            self.showWordDlg = true;
            // self.updateChildInfoHttp();
          }
        } else {
          return false;
        }
      });
    },
    changeGAITFLS(e) {
      console.log("changeGAITFLS", e, Number(e));
      if (Number(e) != NaN) {
        this.$set(
          this.param,
          "realPay",
          Number(this.param.givenPay) == NaN
            ? Number(this.param.givenPay) - 0
            : Number(this.param.realPay_oldp) - Number(this.param.givenPay)
        );
        console.log(this.param);
      }
    },
    handleWord(wordType, tData) {
      //添加
      if (wordType == 1) {
        this.onCreate(tData);
      }
    },
    onCreate(tData) {

      let param = tData;
      console.log(param, '===========')

      for (let index = param.marketOrderRecordDTOList.length; index > 0; index--) {
        console.log(param.marketOrderRecordDTOList[index - 1], index, '1111111111===========')

        if (param.marketOrderRecordDTOList[index - 1].workerId == '') {
          this.$delete(param.marketOrderRecordDTOList, index - 1)
        }
        // const element = array[index];
      }
      if (param.marketOrderRecordDTOList && param.marketOrderRecordDTOList.length) {

      } else {
        param.marketOrderRecordDTOList = null
      }
      // // param.marketOrderRecordDTOList =  == []?null:
      // console.log(param, '22222222221111111111===========')

      // return
      createUserByCard(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          messageUtils.errorMsg(this, response.message);
        } else {
          // this.initData();
          // this.closeWordDlg();
          messageUtils.successMsg(this, response.message);
          // this.show = false;
          this.$emit("handleUpdate");
        }
      });
    },
    updateChildInfoHttp() {
      let param = {
        id: this.childId,
        name: this.param.name,
        petName: this.param.petName,
        birthday: this.param.birthday,
        gender: this.param.gender,
        ...this.param,
        storeLessonCardId: this.param.expCardId,
      };
      createUserByCard(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message);
          this.$emit("handleUpdate");
        } else {
          messageUtils.errorMsg(this, response.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input.is-disabled .el-input__inner {
  background: #ffffff;
}

/deep/ .el-form-item {
  margin-bottom: 10px;
}

/deep/ .el-input__inner {
  height: 35px !important;
  line-height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/user_child/components/UpdateVipTypeInfo.vue